import { render, staticRenderFns } from "./VideoChatContent.vue?vue&type=template&id=08ead9b9"
import script from "./VideoChatContent.vue?vue&type=script&lang=js"
export * from "./VideoChatContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports